import(/* webpackMode: "eager" */ "/home/runner/work/wahni.io/wahni.io/node_modules/next/dist/client/link.js");
